import { render, staticRenderFns } from "./CopyrightFooter.vue?vue&type=template&id=212ac1f0&scoped=true"
import script from "./CopyrightFooter.vue?vue&type=script&lang=ts"
export * from "./CopyrightFooter.vue?vue&type=script&lang=ts"
import style0 from "./CopyrightFooter.vue?vue&type=style&index=0&id=212ac1f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212ac1f0",
  null
  
)

export default component.exports